<template>
  <div class="card-text-card-actions-wrapper d-flex flex-column">
    <v-card-text class="pa-3 pa-sm-5">
      <div v-if="template.templateType === 4" class="d-flex justify-between">
        <p>
          {{ $t("plainTextPaymentPageIntro", { name: templateFullName }) }}
        </p>
        <text-popover
          :text="$t('plainTextPaymentPageInstruction')"
        ></text-popover>
      </div>
      <p v-else>
        {{ $t("plainTextMailIntro", { name: templateFullName }) }}
      </p>
      <v-form>
        <v-row class="my-0">
          <v-col cols="12">
            <v-textarea
              v-model.trim="text"
              :disabled="!userHasAdminRights"
              label="Plain text"
              autocomplete="off"
              spellcheck="false"
              no-resize
              rows="8"
              auto-grow
              outlined
              hide-details
              dense
            >
            </v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <template v-if="userHasAdminRights">
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-end px-6 py-3">
        <v-btn color="primary" :disabled="disableDoneButton" @click="done"
          >Done</v-btn
        >
      </v-card-actions>
    </template>
  </div>
</template>

<script>
import TextPopover from "@/components/globals/TextPopover";
export default {
  name: "PlainTextMail",
  components: {
    TextPopover,
  },
  props: {
    plainText: {
      required: true,
      type: String,
    },
    templateFullName: {
      required: true,
      type: String,
    },
    showDialog: {
      type: Boolean,
      required: true,
    },
    template: {
      type: Object,
      required: true,
    },
    userHasAdminRights: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      text: "",
    };
  },
  computed: {
    disableDoneButton() {
      return this.plainText === this.text;
    },
  },
  watch: {
    showDialog: {
      immediate: true,
      handler(val) {
        if (val) {
          this.text = JSON.parse(JSON.stringify(this.plainText));
        }
      },
    },
  },
  methods: {
    done() {
      this.$emit("update:plain-text", this.text);
      this.$emit("close-dialog");
    },
  },
};
</script>
